var _rect, _circle, _rect2, _rect3, _rect4, _path, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#3C3C3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 61,
    width: 10,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 34,
    width: 10,
    height: 6,
    rx: 3,
    transform: "rotate(90 67 34)",
    fill: "#3C3C3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 61,
    width: 10,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7503 75.0477C69.1646 75.765 70.0819 76.011 70.7994 75.5967C71.5169 75.1824 71.7626 74.2652 71.3484 73.5476L65.7813 63.9051L73.3481 50.799C73.7623 50.0817 73.5165 49.1642 72.799 48.75C72.0816 48.3358 71.1642 48.5817 70.75 49.299L62.75 63.1555C62.7325 63.1857 62.7163 63.2166 62.7011 63.2476C62.4904 63.6805 62.4915 64.2069 62.7503 64.6554C62.7572 64.6676 62.7638 64.6798 62.7712 64.6917L68.7503 75.0477Z",
    fill: "#3C3C3C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 84,
    width: 10,
    height: 6,
    rx: 3,
    transform: "rotate(90 67 84)",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dc970369e985e7740dad9eb3b692540a.svg";
export { ForwardRef as ReactComponent };